<template>
  <v-layout column>
    <v-flex xs12 md12 v-for="card in cards" :key="card.title">
      <v-card class="CSChatThai" style="border-color: white; margin: 4vw; border-style: solid; border-radius: 20px;">
        <v-layout row wrap>
          <v-flex xs8 md8>
            <v-flex xs12 md12 v-if="card.src !== ''">
              <v-img
                :src='card.src'
                style="height: 40vw;"
                @click="gotoLink(card.link)"
              ></v-img>
            </v-flex>
            <v-flex xs12 md12 v-else>
              <v-img
                v-if="filename !== ''"
                :src='filename'
                style="height: 40vw;"
                @click="gotoLink(card.link)"
              ></v-img>
              <v-img
                v-else
                src='/static/img/robot/developer1.png'
                style="height: 40vw;"
                @click="gotoLink(card.link)"
              ></v-img>
            </v-flex>
            <v-flex xs12 md12>
              <v-card-title primary-title>
                <div class="CSChatThai">
                  <h3 class="headline mb-0 CSChatThai">{{card.title}}</h3>
                  <div>{{card.subtitle}}</div>
                </div>
              </v-card-title>
            </v-flex>
          </v-flex>
          <v-layout align-center justify-center row wrap>
            <v-btn flat icon @click="gotoLink(card.link)">
              <v-icon style="font-size: 35px !important; color: #BEC8D2;">arrow_forward_ios</v-icon>
            </v-btn>
          </v-layout>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        search: '',
        searchlistbot: false,
        name: '',
        email: '',
        token: '',
        phone: '',
        status: '',
        webbackend: '',
        filename: '',
        development: '',
        tokenservice: '',
        tokenuserQR: '',
        nameedit: '',
        statusedit: '',
        listbot: [],
        cards: [
          {title: 'ข้อมูล API', src: '', subtitle: 'ข้อมูล API ของผู้พัฒนา', link: '/mobile/develop/profile'},
          {title: 'สรา้งบอท', src: '/static/image/plusbot.png', subtitle: 'คุณสามารถสรา้งบอทที่คุณต้องการ', link: '/mobile/dev_createbot'},
          {title: 'รายการบอท', src: '/static/image/listbot.png', subtitle: 'แสดงรายการบอทที่คุณสรา้งไว้', link: '/mobile/dev_listbot'},
          {title: 'เอกสาร API', src: '/static/image/documents.jpg', subtitle: 'เอกสารเกี่ยวกับ API', link: '/docs'}
        ],
        windowWidth: ''
      }
    },
    created () {
      this.phone = localStorage.getItem('phone')
      this.email = localStorage.getItem('email')
      this.token = localStorage.getItem('tokenuser')
      this.name = localStorage.getItem('name')
      this.status = localStorage.getItem('status')
      this.webbackend = process.env.API
      this.filename = localStorage.getItem('profilepicture')
      this.development = '-'
      this.tokenservice = localStorage.getItem('tokenservice')
      this.tokenuserQR = 'https://com.oneplatform.android.onechat/u/' + btoa(localStorage.getItem('email'))
      this.nameedit = this.name
      this.statusedit = this.status
    },
    methods: {
      findWithAttr (array, attr, value) {
        for (var i = 0; i < array.length; i += 1) {
          if (array[i][attr] === value) {
            return i
          }
        }
        return -1
      },
      gotoLink (link) {
        if (link === 'logout') {
          this.logout()
        } else {
          // console.log(link)
          this.$router.push(link)
        }
      }
    },
    computed: {
      ...mapState({
        myprofile: 'myprofile'
      })
    },
    mounted () {
      this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.windowWidth = window.innerWidth
        })
      })
    },
    watch: {
      windowWidth () {
        if (this.windowWidth > 960) {
          this.$router.push('/develop/homepage')
        }
      },
      myprofile () {
        // console.log('myProfile')
        this.filename = localStorage.getItem('profilepicture')
      }
    }
  }
</script>
<style type="text/css" scoped>
  .CSChatThai {
   font-family: 'CS ChatThaiUI' !important;
   word-wrap: break-word;
  }
</style>


// WEBPACK FOOTER //
// src/components/mobile/HomePageBotMobile.vue